import { render, staticRenderFns } from "./InstallmentProductItemList.vue?vue&type=template&id=bfbf241e&scoped=true"
import script from "./InstallmentProductItemList.vue?vue&type=script&lang=js"
export * from "./InstallmentProductItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbf241e",
  null
  
)

export default component.exports